// 9fbef606107a605d69c0edbcd8029e5d
import NAVIGATION_CONSTANTS, { MERGE_AND_LOAD_NAVIGATION_DATA } from './Navigation.constants';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '../../../../../utils/cache.util';

const initialState = {
  [DEFAULT_REDUCER_KEY]: null,
};

export const mergeNavigationData = (state, action) => {
  const newData = { ...action.payload };

  const updatedNavigationData = state.navigationData.map((l1Obj) => {
    if (newData[l1Obj.categoryId]) {
      const updatedObj = {
        ...l1Obj,
        ...newData[l1Obj.categoryId],
      };
      delete newData[l1Obj.categoryId];
      return updatedObj;
    }
    return l1Obj;
  });

  const remainingData = Object.values(newData);
  if (remainingData.length > 0) {
    updatedNavigationData.push(...remainingData);
  }

  return {
    ...state,
    navigationData: updatedNavigationData,
  };
};

const handleMoreEvents = (state, action) => {
  switch (action.type) {
    case NAVIGATION_CONSTANTS.HIDE_ALL_DRAWERS:
      return {
        ...state,
        l3Drawer: {
          closeDrawer: true,
          openDrawer: false,
        },
        closeDrawer: true,
        openDrawer: false,
        hideNavigationFooter: false,
      };
    case MERGE_AND_LOAD_NAVIGATION_DATA:
      return mergeNavigationData(state, action);
    default:
      return state;
  }
};

const constructNavigationDataObj = (state, action) => {
  return { ...state, ...action.payload, [DEFAULT_REDUCER_KEY]: setCacheTTL() };
};

const NavigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NAVIGATION_CONSTANTS.LOAD_NAVIGATION_DATA:
      return constructNavigationDataObj(state, action);
    case NAVIGATION_CONSTANTS.OPEN_L2_PANEL:
      return {
        ...state,
        ...action,
        openPanel: true,
      };
    case NAVIGATION_CONSTANTS.OPEN_L2_DRAWER:
      return {
        ...state,
        openDrawer: action.payload,
        closeDrawer: false,
      };
    case NAVIGATION_CONSTANTS.HIDE_L2_DRAWER:
      return {
        ...state,
        closeDrawer: true,
        openDrawer: false,
        hideNavigationFooter: false,
      };
    case NAVIGATION_CONSTANTS.OPEN_L3_DRAWER:
      return {
        ...state,
        l3Drawer: {
          openDrawer: action.payload,
          closeDrawer: false,
        },
      };
    case NAVIGATION_CONSTANTS.HIDE_L3_DRAWER:
      return {
        ...state,
        l3Drawer: {
          closeDrawer: true,
          openDrawer: false,
        },
      };
    case NAVIGATION_CONSTANTS.HIDE_NAVIGATION_FOOTER:
      return {
        ...state,
        hideNavigationFooter: true,
      };
    case NAVIGATION_CONSTANTS.SHOW_NAVIGATION_FOOTER:
      return {
        ...state,
        hideNavigationFooter: false,
      };
    case NAVIGATION_CONSTANTS.REMOVE_L1_FOCUS:
      return {
        ...state,
        removeL1Focus: action.payload,
      };
    case NAVIGATION_CONSTANTS.CHECK_NAV_IMAGES_FLAG:
      return {
        ...state,
        checkNavImagesFlag: action.payload,
      };
    default:
      return handleMoreEvents(state, action);
  }
};

export default NavigationReducer;
